var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{staticClass:"cp-page__wrapper"},[_c('list-block',{attrs:{"repository":_vm.repository,"tabs-nav":_vm.tabsNav,"current-tab":'images'},on:{"download":_vm.download}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }